<script lang="typescript">
    import { onDestroy } from "svelte";
    import { push } from "svelte-spa-router";
    import { state, setState } from "./stores.js";
    import { faqs } from "./contactLensFAQs.js";
    import Modal from "./Modal.svelte";

    let showModal = false;
    let modalFAQ;

    onDestroy(() => window.scrollTo(0, 0));

    function toggleModal(faq) {
        modalFAQ = faq;
        showModal = !showModal;
    }
</script>

<section class="justify-center h-screen overflow-y-hidden bg-primary">
    <div class="flex flex-col items-center justify-center h-full page-container bg-primary">
        <h1 class="mb-2 text-5xl font-normal text-white">Frequently asked questions</h1>
        <div class="grid items-center w-full grid-cols-3 gap-3 px-4 py-4">
            {#each faqs as faq, i}
                <button class="faq" on:click={() => toggleModal(faq)}>
                    {faq.question}
                </button>
            {/each}

            {#if showModal}
                <Modal {modalFAQ} on:click={toggleModal} />
            {/if}
        </div>
        <button
            class="px-4 mt-2 btn-secondary btn-sm lg:px-8"
            type="button"
            on:click={() => push("/")}
        >
            Start again
        </button>
    </div>
</section>

<style>
    button.faq {
        @apply bg-primary-light border-0 text-white border-white h-32;
        @apply items-center justify-center text-xl rounded-md;
    }

    .selected {
        @apply bg-white text-primary shadow-inner;
    }
</style>
